import FooterEmailCapture from './FooterEmailCapture'

export default FooterEmailCapture
// eslint-disable-next-line import/export
export * from './FooterEmailCapture'
